<div class="booking-pricelist-dialog" data-test="booking-pricelist-dialog">
  <h3>Dynamisk prislista</h3>

  <div mat-dialog-content>
    @if (loading) {
      <div class="loading" data-test="booking-pricelist-loading">
        <mat-spinner diameter="36"></mat-spinner>
        <p>Hämtar prislista...</p>
      </div>
    }

    @if (!loading && priceList?.prices?.length) {
      <dl class="metadata">
        @if (priceList?.entryDate) {
          <dt>Parkering startdatum:</dt>
          <dd>{{ priceList?.entryDate | date : 'mediumDate' }}</dd>
        }
        @if (priceList?.downloadDate) {
          <dt>Prislista hämtad:</dt>
          <dd>{{ priceList?.downloadDate | date : 'mediumDate' }}</dd>
        }
        @if (priceList?.extraDayPrice !== undefined) {
          <dt>Pris per extra dag:</dt>
          <dd>{{ priceList?.extraDayPrice | currency : 'SEK' : 'symbol' : '1.0-2' }}</dd>
        }
      </dl>
      <div class="table-wrapper">
        <mat-table [dataSource]="priceList?.prices || []">
          <ng-container matColumnDef="days">
            <mat-header-cell *matHeaderCellDef>Dagar</mat-header-cell>
            <mat-cell *matCellDef="let price">{{ price.days }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef>Pris</mat-header-cell>
            <mat-cell *matCellDef="let price">
              {{ price.price | currency : 'SEK' : 'symbol' : '1.0-2' }}
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    }

    @if (!loading && !priceList?.prices?.length) {
      <p class="empty" data-test="booking-pricelist-empty">
        Det finns ingen prislista tillgänglig för bokningen.
      </p>
    }
  </div>

  <div mat-dialog-actions class="actions" align="end">
    <button mat-button (click)="close()">Stäng</button>
  </div>
</div>
